// Mock data for Davway Solutions Landing Page

export const heroData = {
  headline: "Increase Your Service Business Profits — See How Much You're Losing Today",
  subheadline: "At Davway Solutions we help HVAC, Plumbing, and Electrical companies with 3+ techs run smoother, book more jobs, and keep more of their money using FieldPulse's all-in-one business system.",
  ctaText: "Book Free Walk Through",
  ctaLink: "https://form.typeform.com/to/Gu2n6Ax0",
  trustLine: "Secure & Confidential • No Obligation • Takes Less Than 2 Minutes"
};

export const problemsData = [
  { icon: "PhoneMissed", text: "Missed calls & lost jobs" },
  { icon: "CalendarX", text: "Chaotic scheduling" },
  { icon: "Clock", text: "Techs wasting time" },
  { icon: "FileText", text: "Paper estimates & slow invoices" },
  { icon: "Hourglass", text: "Customers paying late" },
  { icon: "CreditCard", text: "High credit card processing fees eating your profit" }
];

export const solutionFeatures = [
  { icon: "Truck", title: "Smart Dispatch & Scheduling", description: "Get the right tech to the right job at the right time" },
  { icon: "FileCheck", title: "Digital Estimates & Invoicing", description: "Create professional proposals in minutes, not hours" },
  { icon: "Zap", title: "Faster Payments", description: "Get paid quicker with integrated payment processing" },
  { icon: "Users", title: "Tech & Job Management", description: "Track your team and jobs in real-time" },
  { icon: "MessageSquare", title: "Customer Communication", description: "Automated texts and emails keep customers informed" },
  { icon: "PiggyBank", title: "Zero Processing Fees", description: "Eliminate credit card fees completely and keep 100% of your profit" }
];

export const profitMetrics = [
  { value: "47%", label: "Fewer Missed Jobs", icon: "Target" },
  { value: "32%", label: "Higher Close Rates", icon: "TrendingUp" },
  { value: "2x", label: "Faster Payments", icon: "Zap" },
  { value: "100%", label: "Card Processing Fee Eliminated", icon: "CreditCard" }
];

export const howItWorksSteps = [
  {
    step: "1",
    title: "Book Your Free Walk Through",
    description: "Schedule a quick call so we can learn about your business and your goals."
  },
  {
    step: "2",
    title: "See Your Custom System",
    description: "We show you exactly how your personalized setup will run your operations and increase profits. No commitment."
  },
  {
    step: "3",
    title: "You Decide",
    description: "If it makes sense for your business, we move forward. If not, no pressure."
  },
  {
    step: "4",
    title: "Get Set Up & Start Running Smoother",
    description: "We handle the setup and you start operating more efficiently and profitably."
  }
];

export const targetAudience = {
  forWho: [
    "HVAC companies",
    "Plumbing companies",
    "Electrical companies",
    "3+ technicians",
    "Growth-focused owners"
  ],
  notForWho: [
    "One-man startups",
    "Hobby businesses",
    "Does not accept card payment"
  ]
};

export const testimonials = [
  {
    quote: "Davway Solutions completely changed how we operate. We're booking more jobs and our cash flow improved within the first month.",
    author: "Mike R.",
    company: "HVAC Ice Hot Services",
    rating: 5
  },
  {
    quote: "Our admin workload dropped and our profits went up. Best decision we made this year.",
    author: "Sarah T.",
    company: "Premier Plumbing Co.",
    rating: 5
  },
  {
    quote: "Since our card processing fee is waived, the system paid for itself after the 1st credit card payment. Highly recommend.",
    author: "James K.",
    company: "Sunset Electrical",
    rating: 5
  }
];

export const trustSignals = [
  { icon: "Lock", text: "Secure & Confidential" },
  { icon: "FileCheck", text: "No Obligation" },
  { icon: "CreditCard", text: "No Impact on Credit" },
  { icon: "Clock", text: "Walk Through Setup in Minutes" }
];

export const contactInfo = {
  email: "randall@davwaysolutions.com",
  ctaLink: "https://form.typeform.com/to/Gu2n6Ax0"
};

export const images = {
  logo: "https://customer-assets.emergentagent.com/job_hvacpro-support/artifacts/2bg0q568_ChatGPT%20Image%20Jan%202%2C%202026%2C%2009_55_38%20PM.png",
  hero: "https://images.pexels.com/photos/8853472/pexels-photo-8853472.jpeg",
  midPage: "https://images.pexels.com/photos/5463587/pexels-photo-5463587.jpeg"
};